<template>
  <!-- MBR029/MBR030 Get Membership — member_app_UI/song_fa_members_membership_tiers -->
  <div :style="styleObject" class="page-header align-items-start mbr-getms">
    <span class="mask bg-white"></span>
    <div class="container">
      <header class="mbr-getms__bar">
        <button type="button" class="mbr-getms__back" :aria-label="$t('common.back')" @click="goBack()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <h1 class="mbr-getms__title">{{ $t('tier.title') }}</h1>
        <span class="mbr-getms__spacer" aria-hidden="true"></span>
      </header>

      <div class="notifications">
        <material-alert v-if="error" color="danger" icon="ni ni-like-2 ni-lg" dismissible>
          {{ error }}
        </material-alert>
      </div>

      <main class="mbr-getms__body" v-if="tier_have_membership_fee_min">
        <section class="mbr-getms__hero">
          <span class="mbr-getms__ring mbr-getms__ring--lg" aria-hidden="true"></span>
          <span class="mbr-getms__ring mbr-getms__ring--sm" aria-hidden="true"></span>
          <div class="mbr-getms__hero-text">
            <span class="mbr-getms__chip">{{
              tier_have_membership_fee_min.is_paid_member_ship ? $t('tier.paid_membership') : $t('tier.free_membership')
            }}</span>
            <h2 class="mbr-getms__hero-title">{{ $t('membership.activate_premium') }}</h2>
            <p class="mbr-getms__hero-tier">{{ tier_have_membership_fee_min.tier_name }}</p>
          </div>
          <div class="mbr-getms__hero-foot">
            <span class="mbr-getms__hero-label">{{ $t('membership.membership_fee') }}</span>
            <span class="mbr-getms__hero-fee">${{ membershipFeeFormatted }}</span>
          </div>
        </section>

        <section class="mbr-getms__panel">
          <ul class="mbr-getms__benefits">
            <li class="mbr-getms__benefit">
              <span class="mbr-getms__tick" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </span>
              <span class="mbr-getms__benefit-text">
                <span class="mbr-getms__benefit-title">
                  {{ $t('membership.pay_and_enjoy', { amount: '$' + membershipFeeFormatted }) }}
                </span>
              </span>
            </li>
            <li class="mbr-getms__benefit">
              <span class="mbr-getms__tick" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </span>
              <span class="mbr-getms__benefit-text">
                <span class="mbr-getms__benefit-title">{{ $t('membership.earn_spend_cashback') }}</span>
              </span>
            </li>
            <li class="mbr-getms__benefit">
              <span class="mbr-getms__tick" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </span>
              <span class="mbr-getms__benefit-text">
                <span class="mbr-getms__benefit-title">{{ $t('membership.unlimited_access') }}</span>
              </span>
            </li>
          </ul>
        </section>

        <section class="mbr-getms__panel" v-if="tier_have_membership_fee_min.description">
          <div class="mbr-getms__panel-head">
            <h3 class="mbr-getms__panel-title">{{ $t('tier.description') }}</h3>
          </div>
          <p class="mbr-getms__text">{{ tier_have_membership_fee_min.description }}</p>
        </section>

        <section class="mbr-getms__panel">
          <div class="mbr-getms__panel-head">
            <h3 class="mbr-getms__panel-title">{{ $t('tier.condition') }}</h3>
          </div>
          <ul class="mbr-getms__rows">
            <li class="mbr-getms__row">
              {{
                tier_have_membership_fee_min.is_paid_member_ship
                  ? $t('tier.paid_membership')
                  : $t('tier.free_membership')
              }}
            </li>
            <li
              class="mbr-getms__row"
              v-if="
                tier_have_membership_fee_min.is_paid_member_ship &&
                tier_have_membership_fee_min.already_achieved_a_paid_tier_previously
              "
            >
              {{ $t('tier.already_paid_tier') }}
            </li>
            <li class="mbr-getms__row" v-if="tier_have_membership_fee_min.is_paid_member_ship">
              {{ $t('tier.membership_fee', { amount: tier_have_membership_fee_min.membership_fee_total_format }) }}
            </li>
            <li
              class="mbr-getms__row"
              v-if="
                tier_have_membership_fee_min.spending_achieve_tier > 0 &&
                tier_have_membership_fee_min.spending_achieve_tier_format
              "
            >
              {{ $t('tier.spend', { amount: tier_have_membership_fee_min.spending_achieve_tier_format }) }}
            </li>
            <li
              class="mbr-getms__row"
              v-if="tier_have_membership_fee_min.duration_achieve_membership"
            >
              {{
                $t('tier.remain_loyalty', {
                  duration: tier_have_membership_fee_min.duration_achieve_membership + ' ' +
                    (tier_have_membership_fee_min.duration_achieve_membership_unit_text?.label ?? ""),
                })
              }}
            </li>
          </ul>
        </section>

        <section class="mbr-getms__panel" v-if="hasBenefit">
          <div class="mbr-getms__panel-head">
            <h3 class="mbr-getms__panel-title">{{ $t('membership.benefit') }}</h3>
          </div>
          <ul class="mbr-getms__benefits">
            <li class="mbr-getms__benefit" v-if="tier_have_membership_fee_min.standard_rule_text">
              <span class="mbr-getms__tick" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </span>
              <span class="mbr-getms__benefit-text">
                <span class="mbr-getms__benefit-title">
                  {{ tier_have_membership_fee_min.standard_rule_text }}
                </span>
              </span>
            </li>
            <li class="mbr-getms__benefit" v-if="tier_have_membership_fee_min.superior_rule_text">
              <span class="mbr-getms__tick" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </span>
              <span class="mbr-getms__benefit-text">
                <span class="mbr-getms__benefit-title">
                  {{ tier_have_membership_fee_min.superior_rule_text }}
                </span>
              </span>
            </li>
            <li class="mbr-getms__benefit" v-if="tier_have_membership_fee_min.welcome_voucher_text">
              <span class="mbr-getms__tick" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </span>
              <span class="mbr-getms__benefit-text">
                <span class="mbr-getms__benefit-title">{{ $t('tier.welcome_benefit') }}</span>
                <span
                  class="mbr-getms__benefit-line"
                  v-for="(line, index) in tier_have_membership_fee_min.welcome_voucher_text.split('---')"
                  :key="index"
                >
                  {{ line ? " - " + line : "" }}
                </span>
              </span>
            </li>
            <li
              class="mbr-getms__benefit"
              v-if="tier_have_membership_fee_min.welcome_direct_cashback_text"
            >
              <span class="mbr-getms__tick" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </span>
              <span class="mbr-getms__benefit-text">
                <span class="mbr-getms__benefit-title">
                  {{ tier_have_membership_fee_min.welcome_direct_cashback_text }}
                </span>
              </span>
            </li>
            <li class="mbr-getms__benefit" v-if="tier_have_membership_fee_min.birthday_voucher_text">
              <span class="mbr-getms__tick" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </span>
              <span class="mbr-getms__benefit-text">
                <span class="mbr-getms__benefit-title">{{ $t('tier.birthday_benefit') }}</span>
                <span
                  class="mbr-getms__benefit-line"
                  v-for="(line, index) in tier_have_membership_fee_min.birthday_voucher_text.split('---')"
                  :key="index"
                >
                  {{ line ? " - " + line : "" }}
                </span>
              </span>
            </li>
            <li
              class="mbr-getms__benefit"
              v-if="showStagingCashback && tier_have_membership_fee_min.birthday_direct_cashback_text"
            >
              <span class="mbr-getms__tick" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </span>
              <span class="mbr-getms__benefit-text">
                <span class="mbr-getms__benefit-title">
                  {{ tier_have_membership_fee_min.birthday_direct_cashback_text }}
                </span>
              </span>
            </li>
            <li
              class="mbr-getms__benefit"
              v-if="showStagingCashback && tier_have_membership_fee_min.birthday_extra_rebase_text"
            >
              <span class="mbr-getms__tick" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </span>
              <span class="mbr-getms__benefit-text">
                <span class="mbr-getms__benefit-title">
                  {{ tier_have_membership_fee_min.birthday_extra_rebase_text }}
                </span>
              </span>
            </li>
          </ul>
        </section>

        <!-- MBR030 payment options -->
        <section class="mbr-getms__panel mbr-getms__pay">
          <label
            class="mbr-getms__option"
            :class="{
              'mbr-getms__option--on': pickedPay === 'One',
              'mbr-getms__option--off': !isWalletSufficient,
            }"
            for="payment-wallet"
          >
            <span class="mbr-getms__option-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M3 7a2 2 0 012-2h11a2 2 0 012 2v1h1a2 2 0 012 2v6a2 2 0 01-2 2h-1v1a2 2 0 01-2 2H5a2 2 0 01-2-2V7zm14 3h3v6h-3a3 3 0 010-6z"
                />
              </svg>
            </span>
            <span class="mbr-getms__option-text">
              {{ $t('membership.use_wallet', { amount: '$' + walletAmountFormatted }) }}
            </span>
            <input
              type="radio"
              id="payment-wallet"
              class="mbr-getms__radio"
              name="payment-exchange"
              value="One"
              v-model="pickedPay"
              :disabled="!isWalletSufficient"
            />
            <span class="mbr-getms__dot" aria-hidden="true"></span>
          </label>

          <label
            class="mbr-getms__option"
            :class="{ 'mbr-getms__option--on': pickedPay === 'Two' }"
            for="payment-credit-card"
          >
            <span class="mbr-getms__option-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                <rect x="2.5" y="5" width="19" height="14" rx="2" />
                <path stroke-linecap="round" d="M2.5 10h19" />
              </svg>
            </span>
            <span class="mbr-getms__option-text">{{ $t('membership.use_credit_card') }}</span>
            <input
              type="radio"
              id="payment-credit-card"
              class="mbr-getms__radio"
              name="payment-exchange"
              value="Two"
              v-model="pickedPay"
            />
            <span class="mbr-getms__dot" aria-hidden="true"></span>
          </label>
        </section>

        <button type="button" class="mbr-getms__cta" @click="processPayment">{{ $t('membership.proceed') }}</button>
      </main>
    </div>

    <div class="position-fixed top-1 end-1 z-index-2">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
    <material-loading :active="loaderActive" />
  </div>
</template>

<script>
import MaterialAlert from "@/components/MaterialAlert.vue";
import { mapMutations, mapActions } from "vuex";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MemberService from "../services/member.service";
import "bootstrap/dist/js/bootstrap.bundle";
import StripeService from "../services/stripe.service";
import AirwallexService from "../services/airwallex.service";
import EventBus from "vue3-eventbus";

const PAYMENT_MODE_STRIPE = 1;
const PAYMENT_MODE_AIRWALLEX = 3;
import TierService from "../services/tier.service";
import MaterialLoading from "@/components/MaterialLoading.vue";
import { localStorageName, getMerchantCode } from "@/config/utils";
import { errorMessage } from "@/utils/errorMessage";

export default {
  name: "get-membership",
  components: {
    MaterialAlert,
    MaterialSnackbar,
    MaterialLoading,
  },
  data() {
    return {
      merchantCode: "",
      memberInfo: {},
      message: "",
      snackbar: "",
      tier_have_membership_fee_min: null,
      pickedPay: "Two",
      tiers: [],
      loaderActive: false,
      nodeEnv: process.env.NODE_ENV,
      // Merchant's preferred card gateway (1 = Stripe, 3 = Airwallex HPP).
      defaultPaymentMode: PAYMENT_MODE_STRIPE,
    };
  },
  mounted() {
    const code = getMerchantCode();
    this.merchantCode = code ? `/${code}` : "";
    this.getTiers();
    this.fetchDefaultPaymentMode();
  },
  // draws its own back header like the design, same chrome as LoyaltyTierBenefit
  beforeMount() {
    this.toggleNavbarOnly();
    this.toggleHideConfig();
    const app = document.querySelector("#app");
    app.classList.add("mbr-sidenav-overlay");
    app.classList.remove("g-sidenav-pinned");
  },
  beforeUnmount() {
    this.toggleNavbarOnly();
    this.toggleHideConfig();
    const app = document.querySelector("#app");
    app.classList.remove("mbr-sidenav-overlay");
    if (window.innerWidth > 1200) {
      app.classList.add("g-sidenav-pinned");
    }
  },
  computed: {
    // Direct cashback/rebate rows stay staging-only, and only alongside a cashback rule.
    showStagingCashback() {
      const tier = this.tier_have_membership_fee_min;
      return (
        this.nodeEnv === "staging" &&
        !!tier &&
        !!(tier.standard_rule_text || tier.superior_rule_text)
      );
    },
    hasBenefit() {
      const tier = this.tier_have_membership_fee_min;
      if (!tier) return false;
      return !!(
        tier.standard_rule_text ||
        tier.superior_rule_text ||
        tier.welcome_voucher_text ||
        tier.welcome_direct_cashback_text ||
        tier.birthday_voucher_text ||
        (this.showStagingCashback &&
          (tier.birthday_direct_cashback_text || tier.birthday_extra_rebase_text))
      );
    },
    styleObject() {
      return {
        "--label-color": this.$store.state.labelColor,
      };
    },
    // Wallet balance as number
    walletBalance() {
      return Number(this.memberInfo.getTotalTopupAmountCanSpent) || 0;
    },
    // Membership fee as number
    membershipFee() {
      return this.tier_have_membership_fee_min
        ? Number(this.tier_have_membership_fee_min.membership_fee_total)
        : 0;
    },
    // Check if wallet has enough balance
    isWalletSufficient() {
      return this.walletBalance >= this.membershipFee;
    },
    // Formatted wallet amount display
    walletAmountFormatted() {
      return this.walletBalance.toFixed(2);
    },
    // Formatted membership fee display
    membershipFeeFormatted() {
      return this.membershipFee.toFixed(2);
    },
  },
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig", "toggleNavbarOnly"]),
    ...mapActions(["setHeaderColor", "setLabelColor", "setButtonColor"]),

    goBack() {
      this.$router.go(-1);
    },

    getMemberInfo() {
      MemberService.getProfile().then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.memberInfo = response.data.data;

            // Redirect if member already on this tier
            if (
              this.tier_have_membership_fee_min &&
              this.memberInfo.member_tier ===
                this.tier_have_membership_fee_min.id
            ) {
              window.location.href = this.merchantCode + "/home";
              return;
            }

            const isCheckMerchantConnectedStripe = localStorage.getItem(
              localStorageName("IS_CHECK_MERCHANT_CONNECTED_STRIPE"),
              "false",
            );

            if (isCheckMerchantConnectedStripe === "false") {
              window.location.href = this.merchantCode + "/home";
              return;
            }

            // Auto-select payment method based on wallet sufficiency
            this.pickedPay = this.isWalletSufficient ? "One" : "Two";
          }
        },
        (error) => {
          console.log(error);
        },
      );
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    fetchDefaultPaymentMode() {
      MemberService.getDefaultPaymentMode().then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.defaultPaymentMode =
              parseInt(response.data.data.default_payment_mode) ||
              PAYMENT_MODE_STRIPE;
          }
        },
        () => {
          // Fall back to Stripe on error.
        },
      );
    },

    processPayment() {
      if (this.loaderActive) return;

      if (this.pickedPay === "Two") {
        this.loaderActive = true;
        const merchantCode = getMerchantCode();
        const url = `${location.protocol}//${location.host}/${merchantCode}/profile`;
        const payment_amount = new Intl.NumberFormat("en", {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        }).format(this.membershipFee);
        const useAirwallex =
          this.defaultPaymentMode === PAYMENT_MODE_AIRWALLEX;

        // Stripe substitutes {CHECKOUT_SESSION_ID}; Airwallex HPP doesn't, so
        // the BE appends `?airwallex_intent_id=…` to the success_url itself.
        const successUrl = useAirwallex
          ? `${url}?price=${this.membershipFee}&tier_id=${this.tier_have_membership_fee_min.id}`
          : `${url}?session_id={CHECKOUT_SESSION_ID}&price=${this.membershipFee}&tier_id=${this.tier_have_membership_fee_min.id}`;

        const dataSend = {
          success_url: successUrl,
          cancel_url: url,
          images: "",
          name: `PAID MEMBERSHIP ${payment_amount}`,
          unit_amount: this.membershipFee,
          quantity: 1,
          member_id: this.memberInfo.id,
          isPaidMembership: 1,
          tier_id: this.tier_have_membership_fee_min.id,
        };

        const checkoutPromise = useAirwallex
          ? AirwallexService.checkoutHppAirwallex(dataSend, merchantCode)
          : StripeService.checkoutSessionStripe(dataSend, merchantCode);

        checkoutPromise.then(
          (response) => {
            if (response.data.result.isSuccess) {
              if (useAirwallex) {
                // Loader stays up while the SDK loads and navigates away.
                AirwallexService.redirectToHpp(response.data.data, () => {
                  this.loaderActive = false;
                }).catch(() => {
                  this.snackbar = "danger";
                  this.message = this.$t("membership.payment_error");
                  this.setTimeOutNotification();
                  this.loaderActive = false;
                });
                return;
              }
              window.location.href = response.data.data.url;
            } else {
              this.snackbar = "danger";
              this.message = errorMessage(response.data.result.message);
              this.setTimeOutNotification();
              this.loaderActive = false;
            }
          },
          (error) => {
            console.log(error);
            this.snackbar = "danger";
            this.message = errorMessage(error, "membership.payment_error");
            this.setTimeOutNotification();
            this.loaderActive = false;
          },
        );
      } else {
        // Pay with Wallet
        const price = this.membershipFee;
        const tier_id = this.tier_have_membership_fee_min?.id;

        if (!price || !tier_id) return;

        this.loaderActive = true;
        const dataForm = { amount: price, tier_id };

        MemberService.assignPaidMembershipRewardsToMemberUsingCashbackTopup(
          dataForm,
        ).then(
          (response) => {
            const dataResponse = response.data;
            if (dataResponse.result.isSuccess) {
              this.snackbar = "success";
              this.message = this.$t("profile.proceed_success");
              this.setTimeOutNotification();
              EventBus.emit("reloadSideNav");
              this.$router.push(this.merchantCode + "/get-member-ship-success");
            } else {
              this.loaderActive = false;
              window.location.href = this.merchantCode + "/home";
            }
          },
          (error) => {
            console.log(error);
            this.loaderActive = false;
          },
        );
      }
    },

    getTiers() {
      const rewardId = this.$route.params.reward_id;
      this.loaderActive = true;

      TierService.getListTier().then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.tiers = response.data.data;
            const exists = this.rewardExists(rewardId, response.data.data);

            if (exists && exists.is_paid_member_ship == 1) {
              this.tier_have_membership_fee_min = exists;
              this.getMemberInfo();
            } else {
              this.$router.push(this.merchantCode + "/home");
            }
          } else {
            this.snackbar = "danger";
            this.message = errorMessage(response.data.result.message);
            this.setTimeOutNotification();
          }
          this.loaderActive = false;
        },
        (error) => {
          this.snackbar = "danger";
          this.message = errorMessage(error);
          this.setTimeOutNotification();
          this.loaderActive = false;
        },
      );
    },

    rewardExists(rewardId, data) {
      return data.find((obj) => obj.id == rewardId);
    },
  },
};
</script>

<style scoped>
/* MBR029/MBR030 Get Membership. */
.mbr-getms.page-header {
  min-height: 100vh;
  padding-bottom: 32px;
  font-family: var(--mbr-font-body);
}

/* Landing/Store ship an unscoped `* { font-family: Poppins }`; `*` hits every element directly so
   inheritance never reaches them. :where() keeps this at zero specificity. */
.mbr-getms :where(:not(.material-icons-round)) {
  font-family: var(--mbr-font-body);
}

.mbr-getms .mask {
  background: var(--mbr-color-canvas) !important;
  opacity: 1;
}

.mbr-getms .container {
  max-width: 440px;
  margin: 0 auto;
}

/* ---- top app bar ---- */
.mbr-getms__bar {
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 24px 20px 16px;
  background: var(--mbr-nav-bg);
  border-bottom: 1px solid rgba(var(--mbr-color-outline-rgb), 0.3);
  backdrop-filter: blur(var(--mbr-nav-blur));
  -webkit-backdrop-filter: blur(var(--mbr-nav-blur));
}

.mbr-getms__back,
.mbr-getms__spacer {
  flex: none;
  width: 40px;
  height: 40px;
}

.mbr-getms__back {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: var(--mbr-color-surface);
  border: 1px solid rgba(var(--mbr-color-outline-rgb), 0.4);
  border-radius: var(--mbr-radius-full);
  box-shadow: 0 1px 2px rgba(var(--mbr-color-primary-rgb), 0.05);
  color: var(--mbr-color-ink-headline);
  transition: transform 0.15s ease;
}

.mbr-getms__back:active {
  transform: scale(0.95);
}

.mbr-getms__back svg {
  width: 20px;
  height: 20px;
}

/* font-family/color set explicitly: Material Dashboard forces Roboto Slab on h1-h3 */
.mbr-getms__title {
  flex: 1 1 auto;
  min-width: 0;
  margin: 0;
  font-family: var(--mbr-font-headline);
  font-size: 18px;
  font-weight: 800;
  line-height: 24px;
  letter-spacing: -0.01em;
  color: var(--mbr-color-ink-headline);
  text-align: center;
}

.mbr-getms__body {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 16px 20px 0;
}

/* ---- MBR029 hero ---- */
.mbr-getms__hero {
  position: relative;
  overflow: hidden;
  padding: 24px;
  border: 1px solid rgba(var(--mbr-color-peach-rgb), 0.2);
  border-radius: var(--mbr-radius-xl);
  background: linear-gradient(135deg, var(--mbr-color-primary) 0%, var(--mbr-color-primary-dark) 100%);
  box-shadow: var(--mbr-shadow-card);
  color: var(--mbr-color-on-primary);
}

.mbr-getms__ring {
  position: absolute;
  border-radius: var(--mbr-radius-full);
  pointer-events: none;
}

.mbr-getms__ring--lg {
  right: -48px;
  bottom: -48px;
  width: 192px;
  height: 192px;
  border: 1px solid rgba(var(--mbr-color-peach-rgb), 0.1);
}

.mbr-getms__ring--sm {
  right: -16px;
  bottom: -16px;
  width: 128px;
  height: 128px;
  border: 1px solid rgba(var(--mbr-color-peach-rgb), 0.15);
}

.mbr-getms__hero-text {
  position: relative;
  z-index: 1;
}

.mbr-getms__chip {
  display: inline-flex;
  align-items: center;
  margin-bottom: 8px;
  padding: 2px 10px;
  border-radius: var(--mbr-radius-full);
  background: var(--mbr-color-peach);
  font-family: var(--mbr-font-headline);
  font-size: 10px;
  font-weight: 800;
  line-height: 16px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--mbr-color-primary);
}

.mbr-getms__hero-title {
  margin: 0;
  font-family: var(--mbr-font-headline);
  font-size: 20px;
  font-weight: 800;
  line-height: 26px;
  letter-spacing: -0.015em;
  color: var(--mbr-color-on-primary);
}

.mbr-getms__hero-tier {
  margin: 4px 0 0;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.04em;
  color: rgba(var(--mbr-color-surface-rgb), 0.7);
}

.mbr-getms__hero-foot {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-top: 28px;
  padding-top: 16px;
  border-top: 1px solid rgba(var(--mbr-color-surface-rgb), 0.1);
}

.mbr-getms__hero-label {
  font-size: 12px;
  line-height: 18px;
  color: rgba(var(--mbr-color-surface-rgb), 0.8);
}

.mbr-getms__hero-fee {
  font-family: var(--mbr-font-headline);
  font-size: var(--mbr-price-md-size);
  font-weight: var(--mbr-price-md-weight);
  line-height: var(--mbr-price-md-line);
  letter-spacing: var(--mbr-price-md-tracking);
  color: var(--mbr-color-peach);
}

/* ---- panels ---- */
.mbr-getms__panel {
  padding: 20px;
  background: var(--mbr-color-card);
  border: 1px solid rgba(var(--mbr-color-outline-rgb), 0.4);
  border-radius: var(--mbr-radius-lg);
  box-shadow: var(--mbr-shadow-card);
}

.mbr-getms__panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(var(--mbr-color-outline-rgb), 0.3);
}

.mbr-getms__panel-title {
  margin: 0;
  font-family: var(--mbr-font-headline);
  font-size: 15px;
  font-weight: 800;
  line-height: 22px;
  letter-spacing: -0.01em;
  color: var(--mbr-color-ink-headline);
}

.mbr-getms__text {
  margin: 16px 0 0;
  font-size: var(--mbr-body-sm-size);
  line-height: 20px;
  color: var(--mbr-color-ink-secondary);
}

.mbr-getms__rows {
  margin: 0;
  padding: 16px 0 0;
  list-style: none;
}

.mbr-getms__row {
  font-size: var(--mbr-body-sm-size);
  line-height: 22px;
  color: var(--mbr-color-ink-secondary);
}

.mbr-getms__benefits {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.mbr-getms__panel-head + .mbr-getms__benefits {
  padding-top: 16px;
}

.mbr-getms__benefit {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.mbr-getms__tick {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin-top: 2px;
  border-radius: var(--mbr-radius-full);
  background: var(--mbr-color-peach);
  color: var(--mbr-color-primary);
}

.mbr-getms__tick svg {
  width: 14px;
  height: 14px;
}

.mbr-getms__benefit-text {
  min-width: 0;
}

.mbr-getms__benefit-title {
  display: block;
  font-size: var(--mbr-body-sm-size);
  font-weight: 700;
  line-height: 18px;
  color: var(--mbr-color-ink-headline);
}

.mbr-getms__benefit-line {
  display: block;
  font-size: 12px;
  line-height: 18px;
  color: rgba(var(--mbr-color-ink-secondary-rgb), 0.8);
}

/* ---- MBR030 payment options ---- */
.mbr-getms__pay {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.mbr-getms__option {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0;
  padding: 14px 16px;
  background: var(--mbr-color-canvas);
  border: 1px solid var(--mbr-color-outline);
  border-radius: var(--mbr-radius-md);
  cursor: pointer;
}

.mbr-getms__option--on {
  background: var(--mbr-color-surface);
  border-color: var(--mbr-color-primary);
  box-shadow: 0 0 0 1px var(--mbr-color-primary) inset;
}

.mbr-getms__option--off {
  opacity: 0.5;
  cursor: not-allowed;
}

.mbr-getms__option-icon {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: var(--mbr-radius-full);
  background: var(--mbr-color-tint);
  color: var(--mbr-color-primary);
}

.mbr-getms__option-icon svg {
  width: 18px;
  height: 18px;
}

.mbr-getms__option-text {
  flex: 1 1 auto;
  min-width: 0;
  font-size: var(--mbr-label-md-size);
  font-weight: var(--mbr-label-md-weight);
  line-height: var(--mbr-label-md-line);
  color: var(--mbr-color-ink-headline);
}

/* the native input stays in the DOM (v-model + the `for`/id pairing) but the
   dot below is what the member sees */
.mbr-getms__radio {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}

.mbr-getms__dot {
  flex: none;
  width: 20px;
  height: 20px;
  border: 2px solid var(--mbr-color-outline);
  border-radius: var(--mbr-radius-full);
  background: var(--mbr-color-surface);
}

.mbr-getms__option--on .mbr-getms__dot {
  border-color: var(--mbr-color-primary);
  border-width: 6px;
}

/* ---- Proceed ---- */
.mbr-getms__cta {
  width: 100%;
  padding: 16px;
  border: 0;
  border-radius: var(--mbr-radius-full);
  background: var(--mbr-color-primary);
  box-shadow: var(--mbr-shadow-card);
  font-family: var(--mbr-font-headline);
  font-size: 15px;
  font-weight: 700;
  line-height: 20px;
  color: var(--mbr-color-on-primary);
  transition: transform 0.15s ease;
}

.mbr-getms__cta:active {
  transform: scale(0.98);
}
</style>
